<template>
<b-modal id="results-modal" size="xl" title="Results Viewer">
    <div class="modal-body text-center">
        <div class="row justify-content-center align-items-center mt-4">
            <div class="col-10 col-md-4">
                <h3>
                    {{ 'BATTLE.OWNER' | translate }}
                    <span v-if="isMe(battle.owner)">(You)</span> - {{ battleResults.owner ? battleResults.owner.winCardIds.length : 0 }}
                </h3>
                <div class="results-display">
                    <Card card="{}" type="new"/>
                    <Card card="{}" type="new"/>
                    <Card v-for="(card, index) in battle.ownerCards" :key="index" :card="card" v-show="index+1 == fight"/>
                </div>              
            </div>
            <div class="col-10 col-md-3">
                <div class="results-content">
                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button @click="fight = 1" :class="{ selected: fight == 1}" type="button" class="btn btn-secondary">
                            {{ 'BATTLE.ONE' | translate }}
                        </button>
                        <button @click="fight = 2" :class="{ selected: fight == 2}" type="button" class="btn btn-secondary">
                            {{ 'BATTLE.TWO' | translate }}
                        </button>
                        <button @click="fight = 3" :class="{ selected: fight == 3}" type="button" class="btn btn-secondary">
                            {{ 'BATTLE.THREE' | translate }}
                        </button>
                    </div>
                    <div class="body-content">
                        <div v-for="(result, index) in battleResults.fights" :key="index" v-show="fight == index+1" class="results-block">
                            <header>
                                {{ 'BATTLE.BATTLE' | translate }} {{ numberMap[index + 1] }}
                            </header>
                            <div class="body-content">
                                <div class="row justify-content-center">
                                    <div class="col-4">
                                        {{ result.owner.AP }}
                                    </div>
                                    <div class="col-3">
                                        <div class="results-type">
                                            AP
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        {{ result.opponent.AP }}
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-4">
                                        {{ result.owner.DP.toFixed(2) }}
                                    </div>
                                    <div class="col-3">
                                        <div class="results-type">
                                            DP
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        {{ result.opponent.DP.toFixed(2) }}
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-4">
                                        {{ result.owner.BT.toFixed(2) }}
                                    </div>
                                    <div class="col-3">
                                        <div class="results-type">
                                            BT
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        {{ result.opponent.BT.toFixed(2) }}
                                    </div>
                                </div>
                            </div>
                            <footer>
                                <div class="row no-gutters">
                                    <div class="col-3 col-sm-2">
                                        <i :class="{ highlight: result.winner == 'owner'}" class="fas fa-check-circle"></i>
                                    </div>
                                    <div class="col-6 col-sm-8">
                                        <span class="result-text">{{ result.winner }} {{ 'BATTLE.WON' | translate }}</span>
                                    </div>
                                    <div class="col-3 col-sm-2">
                                        <i :class="{ highlight: result.winner == 'opponent'}" class="fas fa-check-circle"></i>
                                    </div>
                                </div>                       
                            </footer>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-10 col-md-4">
                <h3>
                    {{ 'BATTLE.OPPONENT' | translate }}
                    <span v-if="isMe(battle.opponent)">(You)</span> - {{ battleResults.opponent ? battleResults.opponent.winCardIds.length : 0 }}
                </h3>
                <div class="results-display">
                    <Card card="{}" type="new"/>
                    <Card card="{}" type="new"/>
                    <Card v-for="(card, index) in battle.opponentCards" :key="index" :card="card" v-show="index+1 == fight"/>
                </div>   
            </div>
        </div>        
    </div>
    <div slot="modal-footer" class="text-center">
        <button type="button" class="btn btn-secondary" @click="hideModal">{{ 'CLOSE' | translate }}</button>
    </div>
</b-modal>
</template>
 
<script>
import { mapGetters } from "vuex";
import Card from "./Card";
import { CHARACTERS, ELEMENTS } from "../util/constants/cards";
import mockData from "../util/constants/mockData";

export default {
    name: "modal-results",
    components: { Card },
    props: [ "title", "id", "content"],
    data () {
        return {
            fight: 1,
            numberMap: { 1: 'One', 2: 'Two', 3: 'Three' }
        }
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
            card: 'getCard',
            battle: 'getBattle',
            battleResults: 'getBattleResults'       
        })
    },
    methods: {
        isMe(address) {
            return this.user.address == address;
        },
        hideModal () {
             this.$root.$emit('bv::hide::modal','results-modal');
        }
    }
};
</script>

<style scoped lang="less">
@import "../assets/less/modal.less";
@import "../assets/less/app.less";

.results-display {
    height: 400px;
    position: relative;
    margin: 30px 0 20px;

    .card-item {
        position: absolute;
        left: 0;

        &:nth-child(1) {
            transform: rotate(5deg);
        }

         &:nth-child(2) {
            transform: rotate(-5deg);
        }
    }
}

.results-content {
    padding: 0 10px;

    .results-block {
        background: #3c3f44;
        border: 1px solid #000;
        margin: 10px 0;
        color: #fff;        

        header {
            padding: 10px;
            margin-bottom: 10px;
            border-bottom: 1px dashed #ccc;
        }

        footer {
            padding: 10px;
            margin-top: 10px;
            border-top: 1px dashed #ccc;

            .fa-check-circle {
                margin-top: 5px;
                color: #ccc;
                
                &.highlight {
                    color: rgb(169, 226, 169);
                }
            }

            .result-text {
                white-space: nowrap;
            }
        }
    }  
}
</style>




// WEBPACK FOOTER //
// src/components/ModalResults.vue